import React, { useEffect, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import QuestionComponent from "../form_formulation/QuestionComponent";
import { FORM_DATA } from "./formData";
import { get, isEmpty } from "lodash";

const FormulationCanvas = ({ responses, customer: { id, user : {gender, phone_number, first_name, email}, experiment_config = null } }) => {
  const [show, setShow] = useState(false);
  const [formType, setFormType] = useState("");
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
  let experimentConfig;
  if (!isEmpty(experiment_config)) {
    experimentConfig = JSON.parse(experiment_config);
  }

  if (gender === "M") {
    setQuestions(FORM_DATA.M);
    setFormType("M");
  } else if (!isEmpty(get(experimentConfig, 'femaleRevamp'))) {
    setQuestions(FORM_DATA.FN);
    setFormType("FN");
  } else {
    setQuestions(FORM_DATA.FO);
    setFormType("FO");
  }
}, [gender, experiment_config]);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const customerData = {
    gender: gender,
    phone_number: phone_number,
    first_name: first_name,
    email: email,
    caseId: id,
  };

  return (
    <>
      <button onClick={handleShow} className="btn btn-primary">
        Retake Hair Test
      </button>

      <Offcanvas show={show} placement="end" onHide={handleClose} style={{"width": "35%"}}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="fs-1">Form Changes</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <QuestionComponent 
            questions={questions}
            responses={responses} 
            customerData={customerData}  
            setShow={setShow}
            formType={formType}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default FormulationCanvas;
